<template>
  <div class="service-types">
    <div class="scrollbar">
      <div
        v-for="serviceType in serviceTypes"
        :key="'service-type-' + serviceType.id"
        class="service-type"
      >
        <el-image
          class="image"
          :src="serviceType.image | thumb64"
          fit="cover"
        />
        <div class="title">
          {{ serviceType.name }}
        </div>
        <span class="edit">
          <svg-icon name="edit" @click="edit(serviceType)" />
          <span class="delete-speciality"><i @click="deleteFunc(serviceType)" class="el-icon-delete"></i></span>
        </span>
      </div>
    </div>

    <div class="buttons">
      <el-button type="warning" round @click="create">
        {{ $t('create') }}
      </el-button>
    </div>

    <el-dialog
      :title="form.id ? $t('edit') : $t('add')"
      :visible.sync="showForm"
      :modal-append-to-body="false"
    >
      <ValidationObserver v-slot="{handleSubmit}">
        <el-form ref="hunterForm">
          <el-row>
            <el-col :span="4">
              <el-upload
                class="photo-uploader"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="updatePhoto"
              >
                <el-image
                  class="image"
                  :src="form.image | thumb64"
                  fit="cover"
                />
              </el-upload>
            </el-col>
            <el-col :span="20">
              <el-form-item :label="$t('name')" prop="name" @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider v-slot="{errors}" name="name" rules="required">
                  <el-input v-model="form.name" type="text" autocomplete="off" />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('priceToBeAgreed')" prop="priceToBeAgreed">
                <el-checkbox v-model="form.priceToBeAgreed" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="text" @click="cancel">
            {{ $t('cancel') }}
          </el-button>
          <el-button type="warning" :loading="isLoading" round @click="handleSubmit(onSubmit)">
            {{ form.id ? $t('save') : $t('add') }}
          </el-button>
        </div>
      </ValidationObserver>
    </el-dialog>
    <el-dialog
      :visible.sync="deleteForm"
      :modal-append-to-body="false"
    >
    <el-row>
      {{ $t('deleteSpeciality') }}
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">
        {{ $t('cancel') }}
      </el-button>
      <el-button type="warning" round @click="deleteSpecialityFunc">
        {{ form.id ? $t('delete') : $t('delete') }}
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getServiceTypes, deleteServiceType } from '@/api/service_types'
  import { createCategory } from '@/api/categories'
  import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
  import { required } from 'vee-validate/dist/rules'

  extend('required', {
    ...required,
    message: 'Campo requerido'
  })

  export default {
    components: {
      ValidationProvider,
      ValidationObserver
    },
    props: {
      industry: Object
    },
    data() {
      return {
        serviceTypes: [],
        showForm: false,
        isLoading: false,
        form: {
          id: null,
          name: '',
          image: null,
          file: null,
          priceToBeAgreed: false
        },
        deleteKeys: {
          id: null,
          termId: null
        },
        deleteForm: false
      }
    },

    watch: {
      industry() {
        this.getList()
      }
    },

    methods: {
      onSubmit() {
        this.isLoading = true
        this.save()
      },
      async getList() {
        const { data } = await getServiceTypes(this.industry)
        this.serviceTypes = data.data
      },

      create() {
        this.showForm = true
      },

      edit(serviceType) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.form.id = serviceType.id
        this.form.name = serviceType.name
        this.form.image = serviceType.image
        this.form.priceToBeAgreed = serviceType.meta.length > 0 ? serviceType.meta[0].price_to_be_agreed : false
        this.form.edit = true
        this.form.termId = serviceType.term_id
        this.showForm = true
      },

      cancel() {
        this.resetForm()
      },

      save() {
        if (this.form.id) {
          this.update()
        } else {
          this.store()
        }
      },

      updatePhoto(file) {
        this.form.file = file.raw
        this.form.image = {
          // eslint-disable-next-line @typescript-eslint/camelcase
          thumb_64: URL.createObjectURL(file.raw)
        }
      },

      async store() {
        createCategory(this.getParam())
          .then(() => {
            setTimeout(() => {
                         this.resetForm()
                         this.isLoading = false
                         this.getList()
                       }
                       , 3000)
          })
      },

      async update() {
        createCategory(this.getParam())
          .then(() => {
            setTimeout(() => {
                         this.resetForm()
                         this.isLoading = false
                         this.getList()
                       }
                       , 3000)
          })
      },

      getParam() {
        const data = new FormData()

        data.append('id', this.industry.id)
        data.append('type', 'ServiceIndustry')

        data.append('children[0][id]', this.form.id)
        data.append('children[0][name]', this.form.name)
        data.append('children[0][meta]', '[{ "price_to_be_agreed":' + this.form.priceToBeAgreed + '}]')
        data.append('children[0][image]', this.form.file)
        if (this.form.edit) {
          data.append('children[0][edit]', true)
          data.append('children[0][termId]', this.form.termId)
        }

        return data
      },

      resetForm() {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.form.id = null
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.form.service_type_id = null
        this.form.image = null
        this.form.file = null
        this.form.name = ''
        this.showForm = false
        this.form.edit = false
        this.form.termId = null

        this.deleteForm = false
      },
      deleteFunc(serviceType) {
        this.deleteKeys.id = serviceType.id
        this.deleteKeys.termId = serviceType.term_id
        this.showForm = false
        this.deleteForm = true
      },
      deleteSpecialityFunc() {
        this.deleteServiceType()
      },
      async deleteServiceType() {
        deleteServiceType(this.deleteKeys)
        .then(() => {
          this.resetForm()
          this.getList()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .service-types {
    position: absolute;
    top: 80px;
    right: 0;
    bottom: 20px;
    left: 0;
    z-index: 600;

    .scrollbar {
      height: 80%;
    }

    .service-type {
      padding: 0 0 40px 0;
      position: relative;

      .image {
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        height: 60px;
        border-radius: 8px;
      }

      .title {
        margin-left: 80px;
        border-bottom: 1px solid #E0E0E0;
        font-weight: 600;
        font-size: 16px;
        line-height: 50px;
        color: $color-text-regular;
      }

      .edit {
        position: absolute;
        top: 10px;
        right: 0;
        cursor: pointer;

        .svg-icon {
          width: 16px;
          height: 16px;
          color: $border-color-light;
        }

        .svg-icon:hover {
          color: $menu-icon-color;
        }
      }
    }

    .photo-uploader {
      position: relative;
      width: 80px;

      .el-image {
        width: 60px;
        height: 60px;
        border-radius: 8px;
      }
    }

    .buttons {
      position: absolute;
      bottom: 0;
      right: 30px;
      width: 220px;
    }

    .delete-speciality{
      margin-left: 10px;
    }
  }
</style>
